import type { ReactNode } from 'react';

import { Stack, Typography } from '@mui/material';

import { DotStyled, type StatusDotColor } from './status-dot.styled';

type StatusDotProps = {
  color: StatusDotColor;
  children: ReactNode;
};

export const StatusDot = (props: StatusDotProps) => {
  const { color, children } = props;

  return (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <DotStyled dotColor={color} />
      <Typography variant="body2">{children}</Typography>
    </Stack>
  );
};
